"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const showElementNotProduct = (comand) => {
    try {
        const notProductBlock = document.querySelector('#not-product-block');
        if (comand === 'show') {
            notProductBlock.classList.add('show');
        }
        if (comand === 'hidden') {
            notProductBlock.classList.remove('show');
        }
    }
    catch (error) {
        console.log('Error in Function showElementNotProduct >>> ', error);
    }
};
exports.default = showElementNotProduct;
